import { defineComponent, onMounted, ref } from 'vue';
import ITableSection from '@/report/models/ITableSection';
import IHeatmapScore from '@/report/models/IHeatmapScore';
import PageVue from '@/report/components/Page.vue';
import ContentWrapperVue from '@/generic/components/ContentWrapper.vue';
import ScoreTooltip from '@/report/fearless/partials/ScoreTooltip.vue';
import { useI18n } from 'vue-i18n';
import i18n from '@/i18n';

export default defineComponent({
    components: {
        ScoreTooltip,
        Page: PageVue,
        ContentWrapper: ContentWrapperVue,
    },
    props: {
        categoryKey: { type: String },
        context: { type: String },
        type: { type: String },
        options: { type: Array },
        heatmap: { type: Object },
    },
    setup(props) {
        const { t } = useI18n();
        const scores = ref([] as IHeatmapScore[]);
        const rows = ref([] as IHeatmapScore[]);
        const titles = ref([] as string[]);
        const loading = ref(false);

        onMounted(async () => {
            loading.value = true;

            if (props.heatmap) {
                scores.value = props.heatmap.entries;
                rows.value = props.heatmap.entries.slice(0, scores.value.length - 1);
                const titlesArray = [...props.heatmap.titles];
                titles.value = titlesArray.splice(1).reverse();
            }

            loading.value = false;
        });

        const getScoreOfCategory = (categories: ITableSection[], category: string) => {
            return categories != null ? categories.find((x) => x.category == category).median : null;
        };

        const heat = (data: number) => {
            let color = '';
            const colors = {
                0: 'red',
                61: 'orange',
                76: 'light-green',
                86: 'green',
            };
            if (!data) {
                return 'secondary';
            }

            Object.keys(colors).forEach((key: string) => {
                if (data >= +key) {
                    color = colors[key];
                }
            });
            return color;
        };

        const translateTitle = (key: string) => {
            const parts = key.split(':');

            if (parts.length < 2) {
                return key;
            }

            if (parts[0] === 'default_country') {
                return `${t('demographics.question.' + parts[0])}:${getCountryTranslation(parts[1])}`;
            }

            if (parts[0] === 'open_question' || parts[0] === 'open') {
                return `${t('demographics.question.' + parts[0])}:${parts[1]}`;
            }

            return `${t('demographics.question.' + parts[0])}:${t('demographics.answer.' + parts[1])}`;
        };

        const getCountryTranslation = (countryCode: string): string => {
            const regionNames = new Intl.DisplayNames([i18n.global.locale], { type: 'region' });
            return regionNames.of(countryCode.toUpperCase());
        };

        return { scores, rows, titles, getScoreOfCategory, heat, loading, translateTitle };
    },
});
